import ua from '../../plugins/userAgent.js';

ua.init();
